import { createClient } from '@/shared/api';
import HOLTER_ECG_DATA_MAP_QUERY from '@/entities/ecg/api/queries/holterEcgDataMap';
import type {
  HolterEcgDataMapQuery,
  HolterEcgDataMapQueryVariables,
} from '@/shared/api/generated/graphql';

export type HolterEcgDataMapEntry = {
  id: string;
  start: string;
  stop: string;
  sampleSize: number;
  dataUrl: string;
  maxHrs: number;
  minHrs: number;
  avgHrs: number;
  channel: number;
  beatFinalPath: string;
  beatPath: string;
  beatInfo: string;
};

export type HolterEcgDataMap = {
  isSuccess: boolean;
  message: string;
  ecgDataMap: {
    samplingFrequency: number;
    gain: number;
    channels: number;
    data: HolterEcgDataMapEntry[];
    querySignature: string;
  };
};

// TODO(ts): typed as the HolterEcgDataMapFilter GraphQL input once its server-side shape is documented
/**
 * Loads the ECG data map that locates a study's waveform files. Runs the holterEcgDataMap query and returns its ecgDataMap on success, throwing the server message otherwise.
 *
 * @param filter - Server-side filter identifying the study and time range.
 * @returns A promise resolving to the ECG data map.
 */
const fetchHolterEcgDataMap = async (filter: any) => {
  const client = await createClient();
  const result = await client.query<HolterEcgDataMapQuery, HolterEcgDataMapQueryVariables>({
    query: HOLTER_ECG_DATA_MAP_QUERY,
    variables: {
      filter,
    },
  });
  const { data } = result;
  const { holterEcgDataMap } = data;
  if (holterEcgDataMap?.isSuccess) {
    return holterEcgDataMap.ecgDataMap;
  }
  throw new Error(holterEcgDataMap.message);
};

export default fetchHolterEcgDataMap;
